import { useMemo } from 'react';
import { ReferenceViewID } from '../referenceViewID/types.ts';
import { parseReferenceViewID } from '../referenceViewID/parseReferenceViewID.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { selectInspectifyReportId } from '../../../redux/features/selectors/orderSelectors.ts';
import { getConfig } from '../../../utils/getConfig.ts';

export const InspectionReportSheet = ({ referenceViewID }: { referenceViewID: ReferenceViewID }) => {
  const parsedId = parseReferenceViewID(referenceViewID);
  const subjectReportId = useAppSelector(selectInspectifyReportId);
  const orderNumber = useAppSelector((state) => state.order.orderNumber);
  const webReportBaseUrl = getConfig('INSPECTIFY_WEB_REPORT_BASE_URL');

  const webReportUrl = useMemo(() => {
    if ('type' in parsedId && parsedId?.type === 'subject') {
      return `${webReportBaseUrl}/orders/${orderNumber}/reports?report_id=${subjectReportId}`;
    }
    return null;
  }, [parsedId, subjectReportId]);

  if (!webReportUrl) {
    return null;
  }
  return (
    <iframe allow="fullscreen" title="Inspection Report" src={webReportUrl} width="100%" height="100%" />
  );
};
